module.exports = __webpack_public_path__ + "d7fe1337e4de55cb66d928cc3988f63e.fbx";